var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 4.32001C9.96314 4.32001 8.01034 5.12907 6.56938 6.56907C5.12938 8.01001 4.32031 9.96291 4.32031 12C4.32031 14.7442 5.78376 17.2791 8.16031 18.6507C10.5369 20.0232 13.4638 20.0232 15.8403 18.6507C18.2169 17.2791 19.6803 14.7442 19.6803 12C19.6803 9.96284 18.8712 8.01003 17.4312 6.56907C15.9903 5.12907 14.0374 4.32001 12.0003 4.32001H12.0003ZM11.151 15.3938L8.09743 12.3386L9.45588 10.9802L11.1528 12.6771L14.5466 9.28611L15.905 10.6446L11.151 15.3938Z",
    fill: "#4EA65A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.51a302473084bf3f9b0da1a57701b75b.svg";
export { ForwardRef as ReactComponent };